import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import axios from "axios";
import "./web_response.css";
import "./mobile_response.css";
import "./gallery.css";

const Buds_stem = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch videos from the backend
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/videos`
        );
        setVideos(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching videos:", error);
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  return (
    <div>
      <Navbar />
      <main className="main_container">
        {/* Home Section */}
        <div className="stem_section">
          <div className="stem_intro">
            <h3 className="home_text" style={{ color: "#c5057d", opacity: 1 }}>
              STEM Buds (School STEM Showcase)
            </h3>
            <p>
              Conversations around STEM Education are not complete without
              involving major stakeholders like Schools. The Schools STEM
              Showcase is an initiative to encourage schools that teach STEM in
              a practical and engaging way.
            </p>
          </div>

          {/* Main Video */}
          <div className="stem_video">
            {loading ? (
              <p>Loading video...</p>
            ) : videos[13] && videos[13].url ? (
              <iframe
                width="560"
                height="315"
                src={videos[13].url}
                title="STEM Buds Video"
                frameBorder="0"
                allowFullScreen
              />
            ) : (
              <p>No video available</p>
            )}
          </div>
        </div>

        {/* Stem Series Section */}
        <div className="video-grid">
          {loading ? (
            <p>Loading videos...</p>
          ) : videos.length >= 17 ? (
            <>
              {/* Video 1 */}
              <div className="video">
                <iframe
                  width="100%"
                  height="100%"
                  src={videos[14].url}
                  title="STEM Buds Video 1"
                  frameBorder="0"
                  allowFullScreen
                />
              </div>

              {/* Video 2 */}
              <div className="video">
                <iframe
                  width="100%"
                  height="100%"
                  src={videos[15].url}
                  title="STEM Buds Video 2"
                  frameBorder="0"
                  allowFullScreen
                />
              </div>

              {/* Video 3 */}
              <div className="video">
                <iframe
                  width="100%"
                  height="100%"
                  src={videos[16].url}
                  title="STEM Buds Video 3"
                  frameBorder="0"
                  allowFullScreen
                />
              </div>
            </>
          ) : (
            <p>No videos available</p>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Buds_stem;
